import { ReactNode, createRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useSwipe } from '../../../app/hooks/swipe';

export const MobileFilterDropDown = ({
  children,
  show,
  onHide,
  onClear,
  isDirty,
}: {
  children: ReactNode;
  show: boolean;
  isDirty: boolean;
  onHide: (res: boolean) => void;
  onClear: () => void;
}) => {
  const ref = createRef<HTMLButtonElement>();
  const { position } = useSwipe(ref, () => onHide(false));

  return (
    <Modal
      onHide={() => onHide(false)}
      show={show}
      size="lg"
      centered
      style={{
        transform: `translate(${0 - position.x}px, ${0 - position.y}px)`,
      }}
    >
      <Modal.Header>
        <Modal.Title>Filter</Modal.Title>
        <Button ref={ref} className="connection-requests-filters--swipe-btn" />
        {isDirty && (
          <Button variant="outline" onClick={onClear}>
            Clear All
          </Button>
        )}
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={() => onHide(false)} className="me-auto">
          Cancel
        </Button>
        <Button variant="primary" onClick={() => onHide(true)}>
          Apply
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
